import { Flex, Text } from '@chakra-ui/react';
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SearchInput } from '@morressier/alembic';
import { FormValues } from './AssignMembers';
import { UseFormSetValue } from 'react-hook-form';

interface Props {
  total: number;
  startIndex: number;
  endIndex: number;
  searchParams: string;
  setValue: UseFormSetValue<FormValues>;
  handleSearch: () => void;
  setSearchValue: (value: string) => void;
  isLoading: boolean;
}

const AssignMembersHeader = ({
  total,
  startIndex,
  endIndex,
  searchParams,
  setValue,
  handleSearch,
  setSearchValue,
  isLoading
}: Props) => {
  return (
    <Flex gap={3} direction="column" alignItems="flex-start">
      <Flex gap={3} direction="column" alignItems="flex-start">
        <FontAwesomeIcon icon={faUserPlus} size="2xl" />
        <Text textStyle="headingGroup">Assign Members</Text>
      </Flex>

      <Text textStyle="textBody">
        {isLoading ? (
          'Loading members...'
        ) : (
          <>
            Showing{' '}
            <Text as="span" fontWeight="bold">
              {total === 0 ? total : `${startIndex} - ${endIndex} of ${total}`}
            </Text>{' '}
            members {total ? `can be assigned to this journal.` : null}
          </>
        )}
      </Text>

      <SearchInput
        placeholder="Search members by name and email"
        name="searchParams"
        value={searchParams}
        disabled={isLoading}
        onChange={e => setValue('searchParams', e.currentTarget.value)}
        onInputClear={() => {
          setSearchValue('');
          setValue('searchParams', '');
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch();
          }
        }}
      />
    </Flex>
  );
};

export default AssignMembersHeader;
